import {API} from "aws-amplify";
import {apiCallParameters} from "src/constants/TechnicianAssignmentTrailConstants";
import {commonApiCallParameters, FALSE} from "src/constants/ApplicationCommonConstants";
import {refreshMidway} from "src/components/authentication/MidwayTokenRetriever";


export const fetchTechnicianAssignmentTrail = async (userLogin: string, payload: string) => {
    let response;
    const credentials = await refreshMidway();
    try {
        response = await API.post(apiCallParameters.TECHNICIAN_ASSIGNMENT_TRAIL_DATA, commonApiCallParameters.EXECUTE_REQUEST, {
            body: {
                'RequestType': apiCallParameters.GET_TRAIL_DATA,
                'EncryptedPayloadRequired': FALSE,
                'Tool': apiCallParameters.TECHNICIAN_ASSIGNMENT_TRAIL_LAMBDA,
                'UserLogin': userLogin,
                'Payload': payload,
                'Token': credentials.token,
                'ClientId': location.host
            },
            headers: {'Content-Type': commonApiCallParameters.CONTENT_TYPE}
        });
        return response;
    }
    catch (error) {
        // TODO: Need to fix this as we are eating up the exception here.
        throw new Error(`Error while calling the fetchTechnicianAssignmentTrail api for input: ${payload}`);
    }
}